import { NotificationBar } from '../../../components';
import { ToastAsync, ToastStatus } from '../toast.type';
import style from './toast-notification.module.scss';
import { getToastErrorDetails } from './toast-notification.function';
import { ReactNode } from 'react';

type PromiseToastNotificationProps = {
  toast: ToastAsync;
  status: ToastStatus;
  icon?: ReactNode;
  closeToast: () => void;
};

const mapToastStatus = (toastStatus: ToastStatus) => {
  switch (toastStatus) {
    case 'error':
      return NotificationBar.STATUS.ERROR;
    case 'info':
      return NotificationBar.STATUS.INFO;
    case 'success':
      return NotificationBar.STATUS.SUCCESS;
    case 'alert':
      return NotificationBar.STATUS.ALERT;
    default:
      return NotificationBar.STATUS.DEFAULT;
  }
};

const getToastMessage = (status: ToastStatus, toast: ToastAsync) => {
  switch (status) {
    case 'info':
      return toast.message;
    case 'success':
      return toast.successMessage;
    case 'error':
      return toast.errorMessage;
    default:
      return toast.message;
  }
};

export const PromiseToastNotification = ({
  toast,
  status,
  icon,
  closeToast
}: PromiseToastNotificationProps) => {
  const { isSupportError, errorMessage, supportIdText } = getToastErrorDetails(
    status,
    toast.message
  );

  return (
    <NotificationBar
      className={style.toastMessage}
      title={status === 'info' ? toast.title : toast.promiseCompleteTitle}
      status={mapToastStatus(status)}
      roundedTop
      roundedBottom
      icon={icon}
      variant={NotificationBar.VARIANT.SECONDARY}
      showDismiss={status !== 'info'}
      highlight={false}
      onDismiss={() => closeToast()}
      buttonPosition={NotificationBar.BUTTON_POSITION.BOTTOM}
      subtitle={
        <>
          {isSupportError ? (
            <>
              <p>{errorMessage}</p>
              <span className={style.greyed}>{supportIdText}</span>
            </>
          ) : (
            getToastMessage(status, toast)
          )}
        </>
      }
    />
  );
};
